import React from 'react';
import { Switch, Route } from 'react-router-dom';

import SignIn from '@pages/SignIn';
import Kit from '@pages/Kit';
import KitExterno from '@pages/KitExterno';

const AuthRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path="/" exact component={SignIn} />
      <Route path="/kit" component={Kit} />
      <Route path="/kit-externo" component={KitExterno} />
    </Switch>
  );
};

export default AuthRoutes;
